import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('motion')
document.body.insertAdjacentHTML('beforeend', stageMarkup({ controls: ['exit', 'hide'] }))
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  const stage = document.querySelector<HTMLElement>('[data-stage-root]')
  const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')
  const speedInput = document.querySelector<HTMLInputElement>('#motion-speed')
  if (!stage || !canvas) return

  canvas.style.background = '#0a0a0a'
  const bar = document.createElement('div')
  bar.style.cssText =
    'position:absolute;top:20%;width:120px;height:60%;background:#e8f56d;border-radius:8px;will-change:transform'
  canvas.appendChild(bar)

  let x = 0
  let raf = 0
  let running = true
  const step = () => {
    if (!running) return
    const speed = Number(speedInput?.value || 4)
    x += speed * 3
    if (x > window.innerWidth + 140) x = -140
    bar.style.transform = `translateX(${x}px)`
    raf = requestAnimationFrame(step)
  }
  raf = requestAnimationFrame(step)

  const close = openStage(stage, {
    onExit: () => {
      running = false
      cancelAnimationFrame(raf)
      close()
    },
  })
})
